import { BpCard } from '../../../../shared/components/cards/card/BpCard'
import { Square } from '../../../../shared/components/utility/square/Square'
import { Controller, useForm } from 'react-hook-form'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { usePostProfileChangeEmailMutation } from '../../../../app/api'
import { FormControls } from '../../../../shared/components/forms/form-controls/FormControls'
import { EMAIL_REGEX } from '../../../../shared/consts/RegularExpressions.const'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './ChangeEmailForm.module.scss'

export interface IChangeEmailFormData {
  password: string
  new_email: string
}

export const ChangeEmailForm = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const [editEmail] = usePostProfileChangeEmailMutation()

  const {
    control,
    getValues,
    handleSubmit,
    formState: { isDirty, isValid },
    reset,
    register,
  } = useForm<IChangeEmailFormData>({
    defaultValues: { password: '', new_email: '' },
    mode: 'onChange',
  })

  return (
    <Square className={className}>
      <form
        onSubmit={handleSubmit((data: IChangeEmailFormData) =>
          editEmail({ changeEmailForm: data }).then((response) => {
            if ('error' in response || !response.data.success) {
              return
            } else {
              reset()
            }
          }),
        )}
      >
        <BpCard
          footer={<FormControls disabled={!isDirty || !isValid} onCancel={() => reset()} />}
          title={t('pages.profile.changeEmail')}
        >
          <div className={clsx(styles.formFields)}>
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('password', { required: t('fields.validate.required') })}
                  required
                  error={error?.message}
                  label={t('pages.profile.fields.password')}
                  placeholder={t('pages.profile.fields.enterPassword')}
                  type='password'
                />
              )}
              control={control}
              name='password'
            />
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('new_email', {
                    required: t('fields.validate.required'),
                    pattern: {
                      value: EMAIL_REGEX,
                      message: t('pages.profile.fields.invalidEmail'),
                    },
                  })}
                  required
                  autoComplete='off'
                  disabled={!getValues('password')}
                  error={error?.message}
                  label={t('pages.profile.fields.newEmail')}
                  placeholder={t('pages.profile.fields.enterNewEmail')}
                  type='email'
                />
              )}
              control={control}
              name='new_email'
            />
          </div>
        </BpCard>
      </form>
    </Square>
  )
}
